import { GetBy } from '../_app/cuchillo/core/Element';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import _Header from '../_app/cuchillo/layout/Header';
import gsap, { Expo, Power2, Power3 } from "gsap";

export default class Header extends _Header {
  static options = {
    show: {
      duration: .3,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static logo;

  static init () {
    super.init();
    Header.logo = GetBy.class("logo", this.container)[0];
    Header.nav = GetBy.selector("nav", this.container)[0];
    
    
    EventDispatcher.addEventListener("FOCUS_ON", () => { this.goFocus(); }, "HEADER");
    EventDispatcher.addEventListener("FOCUS_OFF", () => { this.goNormal(); }, "HEADER");
  }

  static showLogo() {
    gsap.to(Header.logo,
      {
        alpha: 1,
        duration: .2,
        delay: .1,
        ease: Power2.easeOut
      });

    gsap.to(Header.nav,
      {
        alpha: 1,
        duration: .2,
        delay: 1,
        ease: Power2.easeOut
      });

    gsap.to(Header.logo,
      {
        x: 0,
        duration: .8,
        delay: 0,
        ease: Expo.easeOut
      });
  }

  static hideLogo() {

    gsap.to(Header.logo,
      {
        alpha: 0,
        duration: .3,
        delay: 0,
        ease: Power2.easeOut
      });
  }

  static hideAlpha() {
    gsap.to(this.container,
      {
        alpha: 0,
        duration: .3,
        delay: 0,
        ease: Power2.easeOut
      });
  }

  static showAlpha() {
    gsap.to(this.container,
      {
        alpha: 1,
        duration: .3,
        delay: 0,
        ease: Power2.easeOut
      });
  }

  static goFocus() {
    gsap.killTweensOf(this.container);
    
    /*gsap.to(this.container,
      {
        scale: 1.05,
        duration: .4,
        delay: 0,
        ease: Power2.easeIn
      });*/

    gsap.to(this.container,
      {
        alpha: 0,
        duration: .1,
        delay: 0,
        ease: Power2.easeOut
      });
  }

  static goNormal() {
    gsap.killTweensOf(this.container);
    
   /* gsap.to(this.container,
      {
        scale: 1,
        duration: .3,
        delay: .1,
        ease: Power2.easeOut
      });*/

    gsap.to(this.container,
      {
        alpha: 1,
        duration: .2,
        delay: 0,
        ease: Power2.easeOut
      });
  }
}


